import React from "react";
import { Lawn, BanquetHall } from "./importImages.js";
import RoomBookingForm from "./Roombooking.jsx";
import LawnBookingForm from "./Lawnbooking.jsx";
import BanquatBooking from "./Banquathall.jsx";
import BookingPage from "./Founder/SportsBooking.jsx";
import SportsBooking from "./Founder/SportsBooking.jsx";


export default function BookingFormSelector({ facilityType }) {
  switch (facilityType) {
    case "Room":
      return <RoomBookingForm />;
    case "Lawn":
      return <LawnBookingForm />;
    case "BanquetHall":
      return <BanquatBooking/>;
    case "SportsBooking":
      return <SportsBooking/>
    default:
      return null;
  }
}
